export default function PageNotFound() {
    return (
        <div className="center">
            <h1 style={{fontSize: "60px"}}>404</h1>
            <p style={{fontSize: "20px"}}>Page not found</p>
        </div>
    )
}